require("./bootstrap");
require("./alpine/index");
require("./swiper/index");
require("./marquee");
require("./photoswiper/index");

const awardsSection = document.getElementById("awards");
const mainOnCompanySwiper = document.getElementById("main-on-company");
const scrollButton = document.getElementById("scroll-button");

window.addEventListener("scroll", function () {
    if (window.scrollY === 0) {
        scrollButton.classList.add("opacity-0");
        scrollButton.classList.add("pointer-events-none");
        scrollButton.classList.add("!-bottom-4");
    } else {
        scrollButton.classList.remove("opacity-0");
        scrollButton.classList.remove("pointer-events-none");
        scrollButton.classList.remove("!-bottom-4");
    }
});
if (scrollButton) {
    scrollButton.addEventListener("click", () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    });
}

if (mainOnCompanySwiper) {
    document.addEventListener("DOMContentLoaded", () => {
        mainOnCompanySwiper.classList.remove("opacity-0");
    });
}

if (awardsSection) {
    document.addEventListener("DOMContentLoaded", () => {
        awardsSection.classList.remove("opacity-0");
    });
}

let paginationElements = document.querySelectorAll(".pagination_el");
const paginationSection = document.getElementById("pagination-section");

const paginationElementsSearchAndAddListener = () => {
    paginationElements = document.querySelectorAll(".pagination_el");
    paginationElements.forEach((el) => {
        el.addEventListener("click", () => {
            paginationSection.scrollIntoView();
        });
    });
};

if (paginationSection && paginationElements) {
    paginationElementsSearchAndAddListener();
    let paginationMutationObserver = new MutationObserver(function (mutations) {
        paginationElementsSearchAndAddListener();
    });
    paginationMutationObserver.observe(paginationSection, {
        attributes: true,
        childList: true,
        subtree: true,
    });
}
